const images = [
  { preview: 'preview-1', large: 'large-1' },
  { preview: 'preview-2', large: 'large-2' },
  { preview: 'preview-3', large: 'large-3' },
];

export { images };
